export default __webpack_public_path__ + "static/media/fi_above_7.b7943542.png";